import loadable from "@loadable/component";
import { inject, observer } from "mobx-react";
import { Fragment } from "react";

import { AppTray } from "../../core/chrome/AppTray.component";
import { Footer } from "./chrome/Footer.component";
import { Routes } from "../../core/components/Routes";
import { TemplateComponent } from "../TemplateComponent.component";
import PremierePushdownAd from "./chrome/PremierePushdownAd.component";
import { Header } from "./chrome/Header.component";
import { SiteThemeProps } from "../../core/lib/site-theme";
import "./index.style.scss";

const LegalNoticeLoader = loadable(() => import("../../core/page-blocks/legalnotice/LegalNoticeLoader.component"), {
    ssr: false,
});
const LeavingSiteLoader = loadable(() => import("../../core/components/leaving-site/LeavingSiteLoader.component"), {
    ssr: false,
});
const IHRPlayerBar = loadable(() => import("../../core/chrome/IHRPlayerBar.component"), {
    ssr: false,
});
const AuthModal = loadable(() => import("../../core/components/AuthModal.component"), {
    ssr: false,
});

export const PremiereSiteTheme = inject("store")(
    observer(({ store, siteTheme }: SiteThemeProps) => {
        if (!store) {
            return null;
        }

        return (
            <TemplateComponent display="grid">
                <Routes
                    siteTheme={siteTheme}
                    headerGroup={
                        <Fragment>
                            <PremierePushdownAd />
                            <Header />
                        </Fragment>
                    }
                    footerGroup={
                        <Fragment>
                            <LeavingSiteLoader />
                            <Footer />
                            <AppTray />
                            <LegalNoticeLoader />
                            <AuthModal />
                        </Fragment>
                    }
                />
                <IHRPlayerBar />
            </TemplateComponent>
        );
    }),
);

export default PremiereSiteTheme;
